import { post, get } from '../axios'

// 增加return配置
export function config_return_addReturnConfig_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/return/addReturnConfig`,
    map,
    option
  ).then(response => response)
}

// 编辑return配置
export function config_return_editReturnConfig_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/return/editReturnConfig`,
    map,
    option
  ).then(response => response)
}

// 启用
export function config_return_enableConfig_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/return/enableConfig`,
    map,
    option
  ).then(response => response)
}

// 查询操作日志
export function config_return_log_list_activityId_get(map, option) {
  return get(
    `${process.env.VUE_APP_CONFIG}/config/return/log/list/${map.activityId}`,
    map,
    option
  ).then(response => response)
}

// return配置详情
export function config_return_queryReturnConfig_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_CONFIG}/config/return/queryReturnConfig/${map.id}`,
    map,
    option
  ).then(response => response)
}

// return配置列表
export function config_return_queryReturnConfigList_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/return/queryReturnConfigList`,
    map,
    option
  ).then(response => response)
}

// return配置skc列表
export function config_return_queryReturnConfigSkc_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/return/queryReturnConfigSkc`,
    map,
    option
  ).then(response => response)
}

// 上传skc文件
export function config_return_upload_siteId_terminalId_channelId_brandId_post(
  map,
  option
) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/return/upload/${map.siteId}/${map.terminalId}/${map.channelId}/${map.brandId}`,
    map,
    option
  ).then(response => response)
}

// return配置导出
export function config_return_exportReturnSkc_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/return/exportReturnSkc`,
    map,
    option
  ).then(response => response)
}

// no return活动查询
export function config_return_noReturnCategoryQuery_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/return/noReturnCategoryQuery`,
    map,
    option
  ).then(response => response)
}
